export const STATS_BLOCKS = [
	{ key: 'tradeCount', label: 'Trade Count' },
	{ key: 'pnl', label: 'P&L' },
	{ key: 'winRate', label: 'Win Rate' },
	{ key: 'bestTrade', label: 'Best Trade' },
	{ key: 'lobbyRank', label: 'Lobby Rank' },
	{ key: 'sportBreakdown', label: 'Sport Breakdown' },
] as const;
